import React from "react";
import { Link } from "react-router-dom";

export const TeamAreaFiveItem = ({ member }) => {
  return (
    <div className="team-item-five">
      <div className="team-thumb-five">
        <img src={member.src} alt="" />
      </div>

      <div className="team-content-five">
        <h2 className="title">
          <Link to={member.href}>{member.title} </Link>
        </h2>
        <span>{member.designation} </span>

        <div className="team-social-four">
          <ul className="list-wrap">
            <li>
               <Link to='#'>
                <i className="fab fa-facebook-f"></i>
              </Link>
            </li>
            <li>
               <Link to='#'>
                <i className="fab fa-twitter"></i>
              </Link>
            </li>
            <li>
              <Link to='#'>
                <i className="fab fa-instagram"></i>
              </Link>
            </li>
            <li>
              <Link to='#'>
                <i className="fab fa-pinterest-p"></i>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
